// 不支持消息
import React, { memo } from 'react'
import styled from 'styled-components'
import fileMap from "../../constants/log-message/file-type";

const OtherMsg = styled.span`
  display: inline-block;
  background: #ffffff;
  height: 48px;
  border: 1px solid #D9D9D9;
  padding: 15px 16px 0 16px;
  font-size: 12px;
  color: #BFBFBF;
  margin-top: 8px;
`

const RenderOther = memo((props) => {
  const { value } = props
  return (
    <OtherMsg
      style={value.sendType === 2 ? { background: "rgba(82, 196, 26, 0.1)" } : {}}
    >
      {
        value.msgtype === 'voice' && '语音，暂不支持播放'
      }
      {
        value.msgtype !== 'voice' && `${fileMap.get(value.msgtype) ? fileMap.get(value.msgtype) : '未知消息'}，暂不支持查看`
      }
    </OtherMsg>
  )
})

export default RenderOther
